import { render } from "./SupportPage.vue?vue&type=template&id=b0c5c516"
import script from "./SupportPage.vue?vue&type=script&lang=js"
export * from "./SupportPage.vue?vue&type=script&lang=js"

import "./SupportPage.vue?vue&type=style&index=0&id=b0c5c516&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__